/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationDetailForSaas extends models.BillingInformationBase {
    constructor() {
        super();
        this.setDiscriminator("BillingInformationDetailForSaas");
    }

    getFixupPrototypeFunction() { return BillingInformationDetailForSaas.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationDetailForSaas>): BillingInformationDetailForSaas {
        let obj = Object.assign(new BillingInformationDetailForSaas(), model);
        BillingInformationDetailForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationDetailForSaas>): BillingInformationDetailForSaas {
        if (!model) return null;
        return BillingInformationDetailForSaas.newInstance(<BillingInformationDetailForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationDetailForSaas) {
        if (!obj) return;

        models.BillingInformationDetailForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationDetailForSaas): boolean {
        if (models.BillingInformationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationDetailForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.billing_periods) {
            for (let val of this.billing_periods) {
                models.BillingInformationForSaas.fixupPrototype(val);
            }
        }
    }

    /**
     * Details for the billing period.
     */
    billing_periods: Array<models.BillingInformationForSaas>;

}
